import { render, staticRenderFns } from "./DocumentPublic.vue?vue&type=template&id=a2d9e44c&scoped=true&"
import script from "./DocumentPublic.vue?vue&type=script&lang=js&"
export * from "./DocumentPublic.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPublic.vue?vue&type=style&index=0&id=a2d9e44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d9e44c",
  null
  
)

export default component.exports